<template>
    <div>
        <PageTitle :title="$t('simpatizantes.titulo', { simpatizantes: configuracion.simpatizantes, temporada: lista_abonados.nombre })" sectionClass="strech"/>
        <section class="padding-vertical-content pb-0 right-background">
            <div class="thumb-container absolute grayscale light-thumb" :style='"background-image: url(" + footer.bg1_url + ")"'></div>
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <div class="row justify-content-start">
                            <div class="col-12 col-lg-6">
                                <h2 class="m-0 mt-5 h1 text-uppercase">{{ $t('simpatizantes.informacion') }}</h2>
                                <div class="subtitle h3 light mb-3 mb-lg-5">{{ $t('simpatizantes.tu_abono', { simpatizantes: configuracion.simpatizantes, abono: teatro.texto_abono }) }}</div>
                                <div class="thecontent" v-html="configuracion.descripcion_simpatizante">
                                    <div class="mb-lg-5">
                                        <button class="button effect-button large-button my-4 my-lg-4" @click="verForm()"><span>{{ $t('simpatizantes.continuar') }}</span></button>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-lg-4">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        
        <section id="form" class="padding-vertical-content lightgray-content">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <h2 class="m-0 h1 text-uppercase">{{ $t('simpatizantes.completa_datos') }}</h2>
                        <div class="subtitle h3 light mb-3 mb-lg-5">{{ $t('simpatizantes.completa_info', { simpatizantes: configuracion.simpatizantes, abono: teatro.texto_abono }) }}</div>
                        <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
                            <div class="row">
                                <div class="col-12 col-lg-4">
                                    <FormInput :label="$t('formularios.nombre')" id="nommbre" name="nombre" rules="required" v-model="simpatizante.nombre" />
                                </div>
                                <div class="col-12 col-lg-4">
                                    <FormInput :label="$t('formularios.apellidos')" id="apellidos" name="apellidos" rules="required" v-model="simpatizante.apellidos" />
                                </div>
                                <div class="col-12 col-lg-4">
                                    <FormInput v-if="configuracion.hash_teatro == 'BHlBbABzmZ5qkeNOHcGH'" :label="`${$t('formularios.dni')} / ${$t('formularios.pasaporte')}`" id="dni" name="dni" rules="required" v-model="simpatizante.dni" />
                                    <FormInput v-else :label="$t('formularios.dni')" id="dni" name="dni" rules="required" v-model="simpatizante.dni" />
                                </div>
                                <div class="col-12 col-lg-4">
                                    <div class="form-group">
                                        <label for="fecha_nacimiento">{{ $t('formularios.nacimiento') }}</label>
                                        <ValidationProvider name="fecha_nacimiento" rules="required" v-slot="{ errors }">
                                            <datetime
                                                v-model="simpatizante.fecha_nacimiento"
                                                :input-class="'form-control ' + (errors[0] ? 'is-invalid' : '')"
                                                type="date"
                                                input-id="fecha_nacimiento"
                                                min-datetime="1900-01-01"
                                            />
                                            <span class="error">{{ errors[0] }}</span>
                                        </ValidationProvider>
                                    </div>
                                </div>
                                
                                <div class="col-12 col-lg-4">
                                    <FormInput :label="$t('formularios.email')" id="email" name="email" rules="required" v-model="simpatizante.email" />
                                </div>
                                <div class="col-12 col-lg-4">
                                    <FormInput :label="$t('formularios.telefono')" id="telefono" name="telefono" rules="required" v-model="simpatizante.telefono" />
                                </div>
                                <div class="col-12 col-lg-4">
                                    <FormInput :label="$t('formularios.provincia')" id="provincia" name="provincia" rules="required" v-model="simpatizante.provincia" />
                                </div>
                                <div class="col-12 col-lg-4">
                                    <FormInput :label="$t('formularios.localidad')" id="localidad" name="localidad" rules="required" v-model="simpatizante.localidad" />
                                </div>
                                <div class="col-12 col-lg-4">
                                    <FormInput :label="$t('formularios.domicilio')" id="domicilio" name="domicilio" rules="required" v-model="simpatizante.domicilio" />
                                </div>
                                <div class="col-12 col-lg-4">
                                    <FormInput :label="$t('formularios.cp')" id="cp" name="codigo_postal" rules="required" v-model="simpatizante.codigo_postal" />
                                </div>
                                <div class="col-12 col-md-12 col-lg-12" v-if="mostrar_tipo_abonos">
                                    <div class="form-group">
                                        <label for="descuento">{{ $t('formularios.tipo_abono', {abono: teatro.texto_abono}) }}</label>
                                        <ValidationProvider name="descuento" rules="required" v-slot="{ errors }">
                                            <multiselect
                                                :class="(errors[0] ? 'is-invalid' : '')"
                                                v-model="simpatizante.tipo_abono"
                                                :placeholder="$t('formularios.tipo_abono', {abono: teatro.texto_abono})"
                                                label="descripcion"
                                                track-by="id"
                                                :options="zona.tipos_abonos"
                                            />
                                            <small v-if="errors[0]" class="text-danger">{{ $t('formularios.tipo_abono', {abono: teatro.texto_abono}) }}</small>
                                        </ValidationProvider>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-lg-8 p-0 mb-2 mt-2">
                                <FormTerminos
                                    :error="error"
                                    @continuar="aceptarCondiciones"
                                />
                            </div>

                            <div class="form-group">
                                <span>
                                    <b v-if="configuracion.hash_teatro == 'J1fKG9AarPuPNJ5hwY0t' || configuracion.hash_teatro == 'KbG3Jc0gLsXpVHncS9P6'">
                                        {{ $t('simpatizantes.aviso_abono', {abono: teatro.texto_abono}) }}
                                    </b>
                                    <template v-else>
                                        <b v-if="configuracion.hash_teatro == 'hvLux5tvnE5HMsDiXOt2'">{{ $t('simpatizantes.acceso_tercera_femenino', {abono: teatro.texto_abono}) }}</b>
                                        <b v-else-if="configuracion.hash_teatro == 'BHlBbABzmZ5qkeNOHcGH'">{{ $t('simpatizantes.4_entradas', {abono: teatro.texto_abono}) }}</b>
                                        <b v-else>{{ $t('simpatizantes.no_acceso', {abono: teatro.texto_abono}) }}</b>
                                    </template>
                                </span>
                            </div>                        
                            
                            <button class="button large-button effect-button" type="submit"><span>{{ $t('simpatizantes.continuar') }}</span></button>
                        </ValidationObserver>
                    </div>
                </div>
            </div>
        </section>
        
        <transition name="fade" mode="out-in">
            <section v-if="resumen" class="padding-vertical-content" key="resumen" id="resumen">
                <div class="container">
                    <div class="row">
                        <div class="col-12">
                            <h2 class="m-0 h1 text-uppercase">{{ $t('simpatizantes.resumen_compra') }}</h2>
                            <div class="subtitle h3 light mb-3 mb-lg-4 mb-lg-5">{{ $t('simpatizantes.comprueba_info') }}</div>
                            <div class="row justify-content-start">
                                <div class="col-12 col-lg-5">
                                    <ul class="resumen d-block">
                                        <li class="w-100">
                                            <label>{{ $t('simpatizantes.nombre_completo') }}</label>
                                            <div>{{ simpatizante.nombre }} {{ simpatizante.apellidos }}</div>                                            
                                        </li>
                                        <li class="w-100">
                                            <label>{{ $t('formularios.dni') }}</label>
                                            <div>{{ simpatizante.dni }}</div>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-12 col-lg-7">
                                    <label>{{ $t('simpatizantes.tipo_abono', {abono: teatro.texto_abono}) }}</label>
                                    <div class="h2 mt-0 mb-3 gradient-color">{{ simpatizante.tipo_abono.descripcion }}</div>
                                    <label>{{ $t('simpatizantes.precio_abono', {abono: teatro.texto_abono}) }}</label>
                                    <div class="price price-large gradient-color">{{ precio_total | formatear_precio }}</div>
                                    <p class="mb-2 mb-md-4">
                                        <small v-if="!price_management_interno">
                                            * {{ $t('general.el_precio', { precio: $options.filters.formatear_precio(precio), gastos: $options.filters.formatear_precio(price_management), iva: 21, moneda: '€' }) }}
                                        </small>
                                    </p>
                                    <div class="mt-4 mt-lg-4">
                                        <button id="terminar-compra" class="button large-button effect-button" @click="terminar"><span>{{ $t('simpatizantes.continuar') }}</span></button>
                                    </div>
                                    <template v-if="formulario != null">
                                        <div id="formulario-compra" v-html="formulario" v-show="false">
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section v-if="typeof error == 'string'" class="padding-vertical-content" key="resumen" id="resumen">
                <div class="container">
                    <div class="row">
                        <div class="col-12">
                            <h2 class="m-0 h1 text-uppercase">{{ error }}</h2>
                        </div>
                    </div>
                </div>
            </section>
        </transition>
        <transition name="fade" mode="out-in">
            <section v-if="procesar_pago" class="padding-vertical-content lightgray-content mb-3 mb-lg-4" key="pago" id="pago">
                <div class="container">
                    <div class="row">
                        <div class="col-12">
                            <h2 class="m-0 h1 text-uppercase">{{ $t('compra.confirmacion_compra') }}</h2>
                            <div class="subtitle h3 light mb-3 mb-lg-5">{{ $t('compra.introduce_datos') }}</div>
                            <PagoPaycometComponent ref="pago" tipo_venta="simpatizante" :jet_id="jet_id" :session_id="session_id" />
                        </div>
                    </div>
                </div>
            </section>
        </transition>
    </div>
</template>

<script>
    import PageTitle from '@/components/frontend/shared/PageTitle';
    import FormTerminos from '@/components/frontend/components/FormTerminos';
    import PagoPaycometComponent from "@/components/frontend/compra/components/PagoPaycometComponent"

    export default {
        data() {
            return {
                form: false,
                resumen: false,
                formulario: null,
                simpatizante: {},
                terminos: null,
                terminos_error: false,
                precio: null,
                error: false,
                zona: null,
                mostrar_tipo_abonos: false,
                price_management: null,
                price_management_interno: null,
                precio_total: null,
                session_id: null,
                jet_id: null,
                procesar_pago: false
            }
        },
        created() {
            this.getZona();
        },
        computed: {
            lista_abonados() {
                return this.$store.getters.getListaAbonados;
            },
            configuracion() {
                return this.$store.getters.getConfig;
            },
            footer() {
                return this.$store.getters.getFooter;
            },
            teatro(){
                return this.$store.getters.getTeatro
            }
        },
        methods: {
            scrollTo(paso) {
                this.$scrollTo(paso, 100)
            },
            verForm() {
                this.form = true;
                this.$nextTick(function() {
                    this.scrollTo('#form');
                });
            },
            async submit() {
                const isValid = await this.$refs.observer.validate();
                if (!this.terminos) {
                    this.error = true;
                }
                if(isValid && this.terminos) {
                    this.guardarDatos();
                } else {
                    this.terminos_error = true;
                }
            },
            guardarDatos() {
                this.loading = true;

                const params = {
                    filters: {
                        tid: this.configuracion.hash_teatro
                    },
                    datos_comprador: this.simpatizante,
                }    

                this.$store.dispatch(this.config.getVuexAlias('front.guardar.datos.comprador.internacional'), params).then(res => {
                    this.formulario = res.data.formulario;
                    this.jet_id = res.data.jet_id;
                    this.session_id = res.data.session_id;
                    this.precio = res.data.precio;
                    this.precio_total = res.data.precio_total;
                    this.price_management = res.data.gd;
                    this.price_management_interno = res.data.interno;
                    this.loading = false;
                    this.resumen = true;
                    this.error = false;
                    this.$nextTick(function() {
                        this.scrollTo('#resumen');
                    });
                }).catch(error => {
                    this.resumen = false;
                    this.error = 'No hay ninguna tarifa disponible';
                    console.log(error);
                    this.loading = false;
                });
            },
            terminar() {
                if (this.terminos) {
                    if (this.formulario) {
                        setTimeout(() => {
                            document.getElementById('btn-pagar').click();
                        }, 1000);
                    } else {
                        this.procesar_pago = true;
                        this.$nextTick(function() {
                            this.scrollTo('#pago');
                        });
                    }
                } else {
                    this.error = true;
                }
            },
            getZona() {
                const params = {
                    filters: {
                        tid: this.configuracion.hash_teatro,
                        zona_id: 'Internacional'
                    },
                    tid: this.configuracion.hash_teatro,
                    zona_id: 'Internacional'
                }

                this.$store.dispatch(this.config.getVuexAlias('front.zonas.show'), params).then(res => {
                    this.zona = res.data.data;
                    if(this.zona.tipos_abonos.length > 1) {
                        this.mostrar_tipo_abonos = true;
                    } else {
                        this.mostrar_tipo_abonos = false;
                        this.simpatizante.tipo_abono = this.zona.tipos_abonos[0];
                    }
                });
            },
            aceptarCondiciones(continuar) {
                if (continuar == true) {
                    this.terminos = true;
                } else {
                    this.terminos = false;
                }
            },
        },
        components: {
            PageTitle, FormTerminos, PagoPaycometComponent
        },
        beforeDestroy() {
            if (this.procesar_pago) {
                this.$refs.pago.clearAllIntervals();
            }
        }
    }
</script>

<style>
    .fade-enter-active, .fade-leave-active {
        transition: opacity .2s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }

    body .multiselect__tags {
        background-color: #ffffff !important;
    }

</style>
